// passwordの表示/非表示を切り替える
export default class {
  constructor() {
    const iconElms = document.querySelectorAll('.js-form-password-icon');
    const toggleElms = document.querySelectorAll('.js-form-password-toggle');
    toggleElms.forEach((toggleElm) => {
      const targetElms = Array.from(document.querySelectorAll(toggleElm.dataset.target));
      toggleElm.addEventListener('click', () => {
        iconElms.forEach((iconElm) => {
          iconElm.classList.toggle('is-hidden');
        });
        targetElms.forEach((targetElm) => {
          targetElm.type = targetElm.type === 'password' ? 'text' : 'password';
        });
      });
    });
  }
}
